/* eslint-disable react/jsx-no-target-blank */
import React from 'react';
import { Typography } from '@doveit/lego';
import { DefaultElementProps, LinkRendererProps, NodeRendererType } from '@graphcms/rich-text-react-renderer';
import Link from 'next/link';
import Image from 'next/image';
import merge from 'lodash.merge';
import AdvFluidAdapter from '../adv-fluid-adapter/AdvFluidAdapter';
import EvaluationLeadWizardBlock from '../../templates/common/evaluation-lead-wizard-block/EvaluationLeadWizardBlock';

export const renderers = (overrides: NodeRendererType = {}): NodeRendererType => merge({
  h2: ({ children }: DefaultElementProps) => <Typography.H3 tagName="h2">{children}</Typography.H3>,
  h3: ({ children }: DefaultElementProps) => <Typography.H4 tagName="h3">{children}</Typography.H4>,
  p: ({ children }: DefaultElementProps) => <Typography.BODY tagName="p">{children}</Typography.BODY>,
  bold: ({ children }: DefaultElementProps) => <strong>{children}</strong>,
  a: ({
    children, openInNewTab, href, rel, ...rest
  }: LinkRendererProps) => {
    if (!href) {
      return <span>{children}</span>;
    }

    if (href.match(/^https?:\/\/|^\/\//i)) {
      return (
        <a
          href={href}
          target={openInNewTab ? '_blank' : '_self'}
          rel={rel || 'noopener noreferrer'}
          {...rest}
        >
          {children}
        </a>
      );
    }

    return (
      <Link href={href}>
        {children}
      </Link>
    );
  },
  img: ({
    src, altText, height, width, title,
  }) => {
    if (!src) {
      return null;
    }

    return (
      <Image
        src={src}
        alt={altText || title || 'Immagine Dove.it'}
        height={height}
        width={width}
        objectFit="cover"
      />
    );
  },
  embed: {
    AdvFluid: ({ type, variant }) => (
      <div className="embed">
        <AdvFluidAdapter
          advFluidType={type}
          variant={variant}
        />
      </div>
    ),
    EvaluationLeadWizard: ({ title, description }) => (
      <div className="embed">
        <EvaluationLeadWizardBlock
          title={title}
          description={description}
        />
      </div>
    ),
  },

}, overrides);
